"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormValidation = void 0;
exports.isDeepTINValidationRequired = isDeepTINValidationRequired;
exports.isTINRequired = isTINRequired;
exports.isTaxResidencyFieldShownAndRequired = isTaxResidencyFieldShownAndRequired;
exports.isTINAndPersonalIdentificationCodeTheSame = isTINAndPersonalIdentificationCodeTheSame;
exports.isCommunicationLanguageDropdownVisible = isCommunicationLanguageDropdownVisible;
exports.isPhonePasswordTextInputVisible = isPhonePasswordTextInputVisible;
exports.getFieldsOfActivityByChannel = getFieldsOfActivityByChannel;
exports.getEducationByChannel = getEducationByChannel;
exports.getTINInputMask = getTINInputMask;
exports.isCustomFieldOfActivityRequired = isCustomFieldOfActivityRequired;
exports.isIdentityCodeVisible = isIdentityCodeVisible;
exports.isIdentityCodeValueVisible = isIdentityCodeValueVisible;
exports.isTaxPayerCodeSavedAsIdentificationCode = isTaxPayerCodeSavedAsIdentificationCode;
exports.isIdentificationCodeUsedAsTaxPayerCode = isIdentificationCodeUsedAsTaxPayerCode;
exports.isTaxPayerCodeEditable = isTaxPayerCodeEditable;
exports.isCitizenCountryCodeEditable = isCitizenCountryCodeEditable;
exports.getCitizenCountryCodeFieldSettings = getCitizenCountryCodeFieldSettings;
exports.getRegistrationAddressFieldsSettings = getRegistrationAddressFieldsSettings;
exports.getContactAddressFieldSettings = getContactAddressFieldSettings;
exports.getIdentificationCodeFieldSettings = getIdentificationCodeFieldSettings;
exports.getPlaceOfBirthCountryCodeFieldSettings = getPlaceOfBirthCountryCodeFieldSettings;
exports.getTaxResidencyCountryCodeFieldSettings = getTaxResidencyCountryCodeFieldSettings;
const config_1 = require("../config");
const lodash_1 = require("lodash");
const crm_service_enums_1 = require("../clients/http/crm-service/crm-service.enums");
/*
 TIN = Tax identification number
*/
var FormValidation;
(function (FormValidation) {
    FormValidation[FormValidation["OnBoardingFlow"] = 0] = "OnBoardingFlow";
    FormValidation[FormValidation["SelfServicePersonalData"] = 1] = "SelfServicePersonalData";
    FormValidation[FormValidation["SelfServiceConfirmData"] = 2] = "SelfServiceConfirmData";
    FormValidation[FormValidation["CurrentAccountOnboarding"] = 3] = "CurrentAccountOnboarding";
})(FormValidation || (exports.FormValidation = FormValidation = {}));
const customFieldOfActivityMappingIfRequired = {
    [config_1.CountryChannel.AT]: [config_1.FieldOfActivity.ENTREPRENEUR, config_1.FieldOfActivity.OTHER],
    [config_1.CountryChannel.BG]: [config_1.FieldOfActivity.ENTREPRENEUR, config_1.FieldOfActivity.OTHER],
    [config_1.CountryChannel.DE]: [config_1.FieldOfActivity.ENTREPRENEUR, config_1.FieldOfActivity.OTHER],
    [config_1.CountryChannel.EE]: [config_1.FieldOfActivity.ENTREPRENEUR, config_1.FieldOfActivity.OTHER],
    [config_1.CountryChannel.FI]: [config_1.FieldOfActivity.ENTREPRENEUR, config_1.FieldOfActivity.OTHER],
    [config_1.CountryChannel.NL]: [config_1.FieldOfActivity.ENTREPRENEUR, config_1.FieldOfActivity.OTHER],
    [config_1.CountryChannel.LV]: [config_1.FieldOfActivity.ENTREPRENEUR, config_1.FieldOfActivity.OTHER],
    [config_1.CountryChannel.LT]: [config_1.FieldOfActivity.ENTREPRENEUR, config_1.FieldOfActivity.OTHER],
    [config_1.CountryChannel.SE]: [config_1.FieldOfActivity.ENTREPRENEUR, config_1.FieldOfActivity.OTHER]
};
function isDeepTINValidationRequired(location, channel, taxResidency) {
    switch (location) {
        case FormValidation.SelfServicePersonalData:
        case FormValidation.SelfServiceConfirmData:
        case FormValidation.OnBoardingFlow:
        case FormValidation.CurrentAccountOnboarding:
            if ([config_1.CountryChannel.AT, config_1.CountryChannel.DE].includes(channel)) {
                return channel === taxResidency;
            }
            break;
    }
    return false;
}
function isTINRequired(location, channel, taxResidency) {
    if (![
        FormValidation.SelfServicePersonalData,
        FormValidation.SelfServiceConfirmData,
        FormValidation.OnBoardingFlow,
        FormValidation.CurrentAccountOnboarding
    ].includes(location)) {
        throw new Error(`No logic specified for ${FormValidation[location]}`);
    }
    if ([config_1.CountryChannel.AT, config_1.CountryChannel.DE].includes(channel)) {
        return true;
    }
    const isTaxResidencyEmpty = (taxResidency ?? '').trim().length === 0;
    return isTaxResidencyEmpty ? false : channel !== taxResidency;
}
// Deprecated, use getTaxResidencyCountryCodeFieldSettings in the future
function isTaxResidencyFieldShownAndRequired(location, channel, initialTaxResidency) {
    return getTaxResidencyCountryCodeFieldSettings({
        location,
        channel,
        currentValue: initialTaxResidency,
        isDepositCustomer: null
    });
}
function isTINAndPersonalIdentificationCodeTheSame(channel) {
    return [config_1.CountryChannel.NL].includes(channel);
}
function isCommunicationLanguageDropdownVisible(location, channel) {
    switch (location) {
        case FormValidation.SelfServicePersonalData:
            return [config_1.CountryChannel.EE, config_1.CountryChannel.LV].includes(channel);
    }
    return false;
}
function isPhonePasswordTextInputVisible(location, channel) {
    switch (location) {
        case FormValidation.SelfServicePersonalData:
            return [config_1.CountryChannel.LV].includes(channel);
    }
    return false;
}
function getFieldsOfActivityByChannel(location, channel) {
    switch (location) {
        case FormValidation.OnBoardingFlow:
        case FormValidation.SelfServicePersonalData:
        case FormValidation.SelfServiceConfirmData:
            switch (channel) {
                case config_1.CountryChannel.AT:
                case config_1.CountryChannel.BG:
                case config_1.CountryChannel.EE:
                case config_1.CountryChannel.DE:
                case config_1.CountryChannel.NL:
                case config_1.CountryChannel.LV:
                    return [
                        config_1.FieldOfActivity.PRIVATE_SECTOR,
                        config_1.FieldOfActivity.PUBLIC_SECTOR,
                        config_1.FieldOfActivity.ENTREPRENEUR,
                        config_1.FieldOfActivity.INDIVIDUAL_ACTIVITY,
                        config_1.FieldOfActivity.UNEMPLOYED,
                        config_1.FieldOfActivity.PENSIONER,
                        config_1.FieldOfActivity.STUDENT,
                        config_1.FieldOfActivity.PARENTAL_LEAVE,
                        config_1.FieldOfActivity.CONSCRIPT,
                        config_1.FieldOfActivity.OTHER
                    ];
                case config_1.CountryChannel.LT:
                    return [
                        config_1.FieldOfActivity.PRIVATE_SECTOR, config_1.FieldOfActivity.ENTREPRENEUR, config_1.FieldOfActivity.UNEMPLOYED,
                        config_1.FieldOfActivity.PENSIONER, config_1.FieldOfActivity.OTHER
                    ];
                case config_1.CountryChannel.FI:
                    return [
                        config_1.FieldOfActivity.PRIVATE_SECTOR, config_1.FieldOfActivity.ENTREPRENEUR, config_1.FieldOfActivity.INDIVIDUAL_ACTIVITY,
                        config_1.FieldOfActivity.UNEMPLOYED, config_1.FieldOfActivity.PENSIONER, config_1.FieldOfActivity.STUDENT, config_1.FieldOfActivity.OTHER
                    ];
                case config_1.CountryChannel.SE:
                    return [
                        config_1.FieldOfActivity.PRIVATE_SECTOR, config_1.FieldOfActivity.PUBLIC_SECTOR, config_1.FieldOfActivity.ENTREPRENEUR,
                        config_1.FieldOfActivity.UNEMPLOYED, config_1.FieldOfActivity.PENSIONER, config_1.FieldOfActivity.STUDENT, config_1.FieldOfActivity.OTHER
                    ];
            }
            break;
        case FormValidation.CurrentAccountOnboarding:
            switch (channel) {
                case config_1.CountryChannel.EE:
                case config_1.CountryChannel.LV:
                case config_1.CountryChannel.LT:
                    return [
                        config_1.FieldOfActivity.STUDENT,
                        config_1.FieldOfActivity.UNEMPLOYED,
                        config_1.FieldOfActivity.ENTREPRENEUR,
                        config_1.FieldOfActivity.PENSIONER,
                        config_1.FieldOfActivity.PARENTAL_LEAVE,
                        config_1.FieldOfActivity.INDIVIDUAL_ACTIVITY,
                        config_1.FieldOfActivity.PRIVATE_SECTOR,
                        config_1.FieldOfActivity.PUBLIC_SECTOR
                    ];
                default:
                    throw new Error(`Field of activity is not defined for ${location} and ${channel}`);
            }
    }
    return Object.values(config_1.FieldOfActivity);
}
function getEducationByChannel(location, channel) {
    switch (location) {
        case FormValidation.OnBoardingFlow:
        case FormValidation.SelfServicePersonalData:
        case FormValidation.SelfServiceConfirmData:
        case FormValidation.CurrentAccountOnboarding:
            switch (channel) {
                case config_1.CountryChannel.EE:
                case config_1.CountryChannel.LV:
                case config_1.CountryChannel.LT:
                    return [
                        crm_service_enums_1.Education.Basic, crm_service_enums_1.Education.SecondarySpecialised, crm_service_enums_1.Education.Secondary,
                        crm_service_enums_1.Education.Higher
                    ];
                default:
                    return Object.values(crm_service_enums_1.Education);
            }
            break;
    }
    return Object.values(crm_service_enums_1.Education);
}
function getTINInputMask(location, channel) {
    switch (location) {
        case FormValidation.OnBoardingFlow:
        case FormValidation.SelfServicePersonalData:
        case FormValidation.SelfServiceConfirmData:
        case FormValidation.CurrentAccountOnboarding:
            switch (channel) {
                case config_1.CountryChannel.DE:
                    return '11111111111';
                case config_1.CountryChannel.AT:
                    return '11-111/1111';
                case config_1.CountryChannel.NL:
                    return '111111111';
            }
    }
    return null;
}
function isCustomFieldOfActivityRequired(location, channel, fieldOfActivity) {
    switch (location) {
        case FormValidation.OnBoardingFlow:
        case FormValidation.SelfServicePersonalData:
        case FormValidation.SelfServiceConfirmData:
        case FormValidation.CurrentAccountOnboarding:
            if (typeof customFieldOfActivityMappingIfRequired[channel] !== 'undefined') {
                return (customFieldOfActivityMappingIfRequired[channel] ?? []).includes(fieldOfActivity);
            }
            break;
    }
    return false;
}
function isIdentityCodeVisible(location, channel) {
    if (![FormValidation.SelfServicePersonalData, FormValidation.SelfServiceConfirmData].includes(location)) {
        throw new Error(`No logic specified for ${FormValidation[location]}`);
    }
    switch (location) {
        case FormValidation.SelfServicePersonalData:
        case FormValidation.SelfServiceConfirmData:
            return ![config_1.CountryChannel.AT, config_1.CountryChannel.DE].includes(channel);
        default:
            return true;
    }
}
function isIdentityCodeValueVisible(location, channel, identificationCountryCode) {
    if (![FormValidation.SelfServicePersonalData, FormValidation.SelfServiceConfirmData].includes(location)) {
        throw new Error(`No logic specified for ${FormValidation[location]}`);
    }
    switch (location) {
        case FormValidation.SelfServicePersonalData:
        case FormValidation.SelfServiceConfirmData:
            if (channel === config_1.CountryChannel.NL && identificationCountryCode === config_1.CountryChannel.NL) {
                return true;
            }
            if (channel === config_1.CountryChannel.AT || channel === config_1.CountryChannel.DE) {
                return false;
            }
            return true;
        default:
            return true;
    }
}
function isTaxPayerCodeSavedAsIdentificationCode(location, channel, taxResidency) {
    if (![FormValidation.SelfServicePersonalData, FormValidation.SelfServiceConfirmData].includes(location)) {
        throw new Error(`No logic specified for ${FormValidation[location]}`);
    }
    switch (location) {
        case FormValidation.SelfServicePersonalData:
        case FormValidation.SelfServiceConfirmData:
            return [config_1.CountryChannel.AT, config_1.CountryChannel.DE].includes(channel) && taxResidency === channel;
        default:
            return false;
    }
}
function isIdentificationCodeUsedAsTaxPayerCode(location, channel, taxResidency, identificationCountryCode, taxPayerCode) {
    if (![FormValidation.SelfServicePersonalData, FormValidation.SelfServiceConfirmData].includes(location)) {
        throw new Error(`No logic specified for ${FormValidation[location]}`);
    }
    switch (location) {
        case FormValidation.SelfServicePersonalData:
        case FormValidation.SelfServiceConfirmData:
            if ([config_1.CountryChannel.AT, config_1.CountryChannel.DE].includes(channel) && taxResidency === channel && identificationCountryCode === channel) {
                const isNullOrUndefined = (0, lodash_1.isNull)(taxPayerCode) || (0, lodash_1.isUndefined)(taxPayerCode);
                const isNotStringOrEmptyString = !(0, lodash_1.isString)(taxPayerCode) || (taxPayerCode ?? '').trim().length === 0;
                return isNullOrUndefined || isNotStringOrEmptyString;
            }
            return false;
        default:
            return false;
    }
}
function isTaxPayerCodeEditable(location, channel, taxResidency) {
    if (![FormValidation.SelfServicePersonalData, FormValidation.SelfServiceConfirmData].includes(location)) {
        throw new Error(`No logic specified for ${FormValidation[location]}`);
    }
    switch (location) {
        case FormValidation.SelfServicePersonalData:
        case FormValidation.SelfServiceConfirmData:
            if (channel === config_1.CountryChannel.NL) {
                return taxResidency !== config_1.CountryChannel.NL;
            }
            return true;
        default:
            return true;
    }
}
function isCitizenCountryCodeEditable(location) {
    if (![FormValidation.SelfServicePersonalData, FormValidation.SelfServiceConfirmData].includes(location)) {
        throw new Error(`No logic specified for ${FormValidation[location]}`);
    }
    switch (location) {
        case FormValidation.SelfServiceConfirmData:
            return true;
        default:
            return false;
    }
}
function getCitizenCountryCodeFieldSettings(location, channel) {
    if (![FormValidation.SelfServicePersonalData, FormValidation.SelfServiceConfirmData].includes(location)) {
        throw new Error(`No logic specified for ${FormValidation[location]}`);
    }
    if ([config_1.CountryChannel.FI, config_1.CountryChannel.AT, config_1.CountryChannel.DE, config_1.CountryChannel.NL].includes(channel)) {
        return {
            visible: true,
            editable: false
        };
    }
    else {
        return {
            visible: true,
            editable: true
        };
    }
}
function getRegistrationAddressFieldsSettings(location, channel) {
    if (![FormValidation.SelfServicePersonalData, FormValidation.SelfServiceConfirmData].includes(location)) {
        throw new Error(`No logic specified for ${FormValidation[location]}`);
    }
    const countyVisibleChannels = [config_1.CountryChannel.EE, config_1.CountryChannel.LV, config_1.CountryChannel.LT, config_1.CountryChannel.BG];
    const countyOptionalChannels = [config_1.CountryChannel.LV];
    const visibleRequiredEditable = { visible: true, required: true, editable: true };
    const hiddenAndOptional = { visible: false, required: false, editable: false };
    if (channel === config_1.CountryChannel.EE) {
        return {
            visible: location !== FormValidation.SelfServiceConfirmData,
            editable: location !== FormValidation.SelfServiceConfirmData,
            fields: location === FormValidation.SelfServiceConfirmData
                ? {
                    county: hiddenAndOptional,
                    city: hiddenAndOptional,
                    postcode: hiddenAndOptional,
                    address: hiddenAndOptional
                } : {
                county: {
                    visible: countyVisibleChannels.includes(channel),
                    editable: countyVisibleChannels.includes(channel),
                    required: !countyOptionalChannels.includes(channel)
                },
                city: visibleRequiredEditable,
                postcode: visibleRequiredEditable,
                address: visibleRequiredEditable
            }
        };
    }
    return {
        visible: true,
        editable: channel !== config_1.CountryChannel.FI,
        fields: {
            county: {
                visible: countyVisibleChannels.includes(channel),
                editable: countyVisibleChannels.includes(channel),
                required: countyVisibleChannels.includes(channel) && !countyOptionalChannels.includes(channel)
            },
            city: visibleRequiredEditable,
            postcode: visibleRequiredEditable,
            address: visibleRequiredEditable
        }
    };
}
function getContactAddressFieldSettings(location, channel) {
    const visibleRequiredEditable = { visible: true, required: true, editable: true };
    if ([config_1.CountryChannel.FI].includes(channel)) {
        return {
            visible: false,
            editable: false,
            fields: {
                county: {
                    visible: false,
                    required: false,
                    editable: false
                },
                city: visibleRequiredEditable,
                postcode: visibleRequiredEditable,
                address: visibleRequiredEditable
            }
        };
    }
    else if ([config_1.CountryChannel.EE].includes(channel)) {
        return {
            visible: true,
            editable: true,
            fields: {
                county: {
                    visible: true,
                    required: true,
                    editable: true,
                },
                city: visibleRequiredEditable,
                postcode: visibleRequiredEditable,
                address: visibleRequiredEditable
            }
        };
    }
    return getRegistrationAddressFieldsSettings(location, channel);
}
function getIdentificationCodeFieldSettings(location, channel, taxResidency, identificationCodeCountryCode) {
    if (![FormValidation.SelfServicePersonalData, FormValidation.SelfServiceConfirmData].includes(location)) {
        throw new Error(`No logic specified for ${FormValidation[location]}`);
    }
    if ([config_1.CountryChannel.AT, config_1.CountryChannel.DE].includes(channel)) {
        const isReplacedWithTaxPayerCode = taxResidency === channel;
        return {
            empty: true,
            visible: false,
            editable: false,
            saveable: isReplacedWithTaxPayerCode,
            replacedWithTaxPayerCodeValueOnSave: isReplacedWithTaxPayerCode
        };
    }
    else if (channel === config_1.CountryChannel.NL) {
        return {
            empty: identificationCodeCountryCode !== channel,
            visible: true,
            editable: false,
            saveable: false,
            replacedWithTaxPayerCodeValueOnSave: false
        };
    }
    else {
        return {
            empty: false,
            visible: true,
            editable: false,
            saveable: false,
            replacedWithTaxPayerCodeValueOnSave: false
        };
    }
}
function getPlaceOfBirthCountryCodeFieldSettings(opts) {
    const { location, channel, isDepositCustomer, currentValue } = opts;
    const isFormSupported = [
        FormValidation.SelfServicePersonalData,
        FormValidation.SelfServiceConfirmData,
        FormValidation.OnBoardingFlow,
        FormValidation.CurrentAccountOnboarding
    ].includes(location);
    if (!isFormSupported) {
        throw new Error(`No logic specified for ${FormValidation[location]}`);
    }
    const isFieldFilled = ((currentValue ?? '').trim()).length > 0;
    if ([config_1.CountryChannel.FI].includes(channel)) {
        return {
            required: isDepositCustomer === true,
            visible: isDepositCustomer === true,
            editable: isDepositCustomer === true && !isFieldFilled
        };
    }
    else {
        return {
            required: false,
            visible: false,
            editable: false
        };
    }
}
function getTaxResidencyCountryCodeFieldSettings(opts) {
    const { location, channel, isDepositCustomer, currentValue } = opts;
    if (![
        FormValidation.SelfServicePersonalData,
        FormValidation.SelfServiceConfirmData,
        FormValidation.OnBoardingFlow,
        FormValidation.CurrentAccountOnboarding
    ].includes(location)) {
        throw new Error(`No logic specified for ${FormValidation[location]}`);
    }
    const isFieldFilled = ((currentValue ?? '').trim()).length > 0;
    const isSelfService = [FormValidation.SelfServiceConfirmData, FormValidation.SelfServiceConfirmData].includes(location);
    const isOnboardingOrConfirmData = [FormValidation.OnBoardingFlow, FormValidation.CurrentAccountOnboarding, FormValidation.SelfServiceConfirmData].includes(location);
    if (config_1.CountryChannel.FI === channel && isSelfService) {
        return {
            visible: isFieldFilled || isDepositCustomer === true,
            required: isFieldFilled || isDepositCustomer === true,
            editable: isFieldFilled || isDepositCustomer === true
        };
    }
    if (isOnboardingOrConfirmData || [config_1.CountryChannel.AT, config_1.CountryChannel.DE].includes(channel)) {
        return {
            visible: true,
            required: true,
            editable: true
        };
    }
    return {
        visible: isFieldFilled,
        required: isFieldFilled,
        editable: isFieldFilled
    };
}
